import { render, staticRenderFns } from "./HorseCroissance.vue?vue&type=template&id=0813c28e&"
import script from "./HorseCroissance.vue?vue&type=script&lang=js&"
export * from "./HorseCroissance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports